import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 

import { CardboxOneComponent } from './cardbox-one.component'; 

@NgModule({
  declarations: [CardboxOneComponent],
  exports: [CardboxOneComponent],
  imports: [
    CommonModule, 
  ]
})
export class CardboxOneModule {}
